require("./bootstrap");
window.Vue = require("vue").default;

import { router } from "./modules/routes";
import { store } from "./vuex/store";
import vuetify from "./modules/vuetify";
import i18n from "./modules/i18n";
import { localize } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import { ValidationProvider } from "vee-validate";
import VueGoogleCharts from "vue-google-charts";

import en from "vee-validate/dist/locale/en.json";
import it from "vee-validate/dist/locale/it.json";
import Options from "./modules/Options";
import Functions from "./modules/Functions";
import Tooltips from "./modules/Tooltips";
import Formatters from "./modules/Formatters";
import { VueMaskDirective } from "v-mask";
import Permissions from "./mixins/Permissions";

Vue.use(Options);
Vue.use(Functions);
Vue.use(Tooltips);
Vue.use(Formatters);
Vue.directive("mask", VueMaskDirective);
Vue.use(require("./modules/materialchart.js"));
Vue.use(VueGoogleCharts);
Vue.mixin(Permissions);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("auth-layout", require("./components/auth/AuthLayout").default);

//******************************* ADMIN ***************************************************/
//CLIENTS
Vue.component("create-edit-adminclients", require("./components/admin/clients/CreateEditAdminClients").default);
Vue.component("import-adminclients", require("./components/admin/clients/ImportAdminClients").default);
//INCOMEDECLARATIONS
Vue.component("create-edit-adminincomedeclarations", require("./components/admin/incomedeclarations/CreateEditAdminIncomeDeclarations").default);
Vue.component("import-adminincomedeclarations", require("./components/admin/incomedeclarations/ImportAdminIncomeDeclarations").default);
//INVOICES
Vue.component("create-edit-admininvoices", require("./components/admin/invoices/CreateEditAdminInvoices").default);
Vue.component("import-admininvoices", require("./components/admin/invoices/ImportAdminInvoices").default);
//USERS
Vue.component("create-edit-adminusers", require("./components/admin/users/CreateEditAdminUsers").default);
//YEARDATA
Vue.component("create-edit-yeardata", require("./components/admin/yeardata/CreateEditYearData").default);
//*****************************************************************************************/

//ATTACHMENT
Vue.component("attachment-list", require("./components/attachment/AttachmentList").default);
Vue.component("create-edit-attachment", require("./components/attachment/CreateEditAttachment").default);
Vue.component("download-attachment", require("./components/attachment/DownloadAttachment").default);
//INCOMEDECLARATIONS
Vue.component("create-edit-incomedeclarations", require("./components/incomedeclarations/CreateEditIncomeDeclarations").default);
//INVOICES
Vue.component("create-edit-invoices", require("./components/invoices/CreateEditInvoices").default);
Vue.component("import-invoices", require("./components/invoices/ImportInvoices").default);
//SYSTEM-MESSAGES
Vue.component("systemmessages-toread", require("./components/systemmessages/SystemMessagesToRead").default);
//TENANT
Vue.component("edit-tenant", require("./components/tenant/EditTenant").default);
Vue.component("autocomplete-organizations", require("./components/tenant/AutocompleteOrganizations").default); //ELIMINARE?
//COMMONS
Vue.component("attachments", require("./components/commons/Attachments").default);
Vue.component("attachments-badge", require("./components/commons/AttachmentsBadge").default);
Vue.component("base-item", require("./components/commons/ListItem").default);
Vue.component("base-item-group", require("./components/commons/ListItemGroup").default);
Vue.component("create-edit-layout", require("./components/commons/CreateEditLayout").default);
Vue.component("material-export", require("./components/commons/MaterialExport").default);
Vue.component("material-import", require("./components/commons/MaterialImport").default);
Vue.component("material-stats", require("./components/commons/MaterialStats").default);
Vue.component("material-card", require("./components/commons/MaterialCard").default);
Vue.component("material-table", require("./components/commons/MaterialTable").default);
Vue.component("material-alert", require("./components/commons/MaterialAlert").default);
Vue.component("material-dialog", require("./components/commons/MaterialDialog").default);
Vue.component("material-popup", require("./components/commons/MaterialPopup").default);
Vue.component("main-container", require("./components/commons/MainContainer").default);
Vue.component("server-down", require("./components/commons/ServerDown").default);
Vue.component("action-button", require("./components/commons/ActionButton").default);
Vue.component("slot-no-data", require("./components/commons/SlotNoData").default);
Vue.component("info-box", require("./components/commons/InfoBox").default);
Vue.component("search-box", require("./components/commons/SearchBox").default);
Vue.component("date-field", require("./components/commons/DateField").default);
Vue.component("price-field", require("./components/commons/PriceField").default);
Vue.component("instant-edit", require("./components/commons/InstantEdit").default);
Vue.component("list-content-value", require("./components/commons/ListContentValue").default);
Vue.component("read-more-text", require("./components/commons/ReadMoreText").default);
Vue.component("upload-file", require("./components/commons/UploadFile").default);

//Vee Validate
localize({
	en,
	it,
});
localize("it");
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { setInteractionMode } from "vee-validate";
import { reject } from "lodash";

setInteractionMode("eager");
Object.keys(rules).forEach((rule) => {
	extend(rule, {
		...rules[rule],
	});
});
extend("date_between", {
	params: ["firstDate", "secondDate"],
	validate: (value, { firstDate, secondDate }) => {
		if (moment(value, "DD/MM/YYYY").isSameOrAfter(moment(firstDate, "DD/MM/YYYY")) && moment(value, "DD/MM/YYYY").isSameOrBefore(moment(secondDate, "DD/MM/YYYY"))) {
			return true;
		}
		return false;
	},
	message: "La data inserita deve essere compresa tra {firstDate} e {secondDate}.",
});
extend("date_format", {
	validate: (value) => {
		if (moment(value, "DD/MM/YYYY", true).isValid()) {
			return true;
		}
		return false;
	},
	message: "La data inserita deve essere nel formato GG/MM/AAAA",
});
extend("time_after", {
	params: ["firstTime"],
	validate: (value, { firstTime }) => {
		if (!value) {
			return true;
		}
		if (moment(value, "H:i:s").isSameOrAfter(moment(firstTime, "H:i:s"))) {
			return true;
		}
		return false;
	},
	message: "Devi inserire un orario successivo a {firstTime}.",
});

const app = new Vue({
	el: "#app",
	beforeCreate() {
		this.$store.commit("getAccessFromCookie");
	},
	created() {
		window.axios.interceptors.response.use(
			function (response) {
				if (response.data.timeout) {
					store.commit("setTimeout", response.data.timeout);
				}
				return Promise.resolve(response);
			},
			function (error) {
				switch (error.response.status) {
					case 400:
						if (error.response.data.errormessage) {
							store.commit("showSnackbar", {
								message: error.response.data.errormessage,
								color: "error",
								duration: 5000,
							});
						}
						return Promise.reject(error);

					case 401:
						store.commit("authError", "unauthorized");
						if (store.getters.isAuthenticated) {
							store.dispatch("alreadyLoggedOut").then(() => {
								router.push("/login");
								setTimeout(() => {
									store.commit("showSnackbar", {
										message: i18n.t("global.session_expired"),
										color: "error",
										duration: 3000,
									});
								}, 500);
							});
						} else {
							if (router.history.current.path !== "/login") {
								router.push("/login");
							}
						}
						break;
					case 429:
						let time = 60;
						if (error.response.headers) {
							if (error.response.headers["retry-after"]) {
								time = error.response.headers["retry-after"];
							}
						}
						store.commit("showDialog", {
							type: "alert",
							title: i18n.t("global.too_many_request"),
							message: i18n.t("global.too_many_request_message", { time: Vue.prototype.$appFormatters.seconds(time) }),
						});
						return Promise.reject(error);
						break;
					case 503:
						window.location.reload();
						break;
					case 404:
						router.push("/dashboard").catch(() => {});
						return Promise.reject(error);
					default:
						return Promise.reject(error);
				}
			}
		);
	},
	vuetify,
	store,
	router,
	i18n,
});
